import { sectionTitleSlide } from '../shared/section-title-slide';

export const salesAttributionTitleSlide =
  sectionTitleSlide('Sales Attribution');
